export const HEADER_COLLAPSED_HEIGHT = 133

export const SBX_MAX_HEADER_HEIGHT = 163
export const SBX_MIN_HEADER_HEIGHT = 40

export const createHeaderBackgroundImage = (isArtist: boolean, artistHeaderUrl: string) => {
  if (isArtist && artistHeaderUrl) {
    return {
      backgroundImage: `url('${artistHeaderUrl}')`,
      animation: 'unset'
    }
  }
  return {
    // backgroundSize:
    // posY && posY < HEADER_COLLAPSED_HEIGHT ? `calc(100% - ${posY / (HEADER_COLLAPSED_HEIGHT / 10)}%)` : '100%'
  }
}
